<template>
  <el-dialog
    v-model="visible"
    :title="title"
    width="600px"
    append-to-body
    :before-close="close"
  >
    <el-form
      :model="editForm"
      ref="editFormRef"
      label-width="80px"
      :rules="rules"
    >
      <el-form-item label="链接名称" prop="linkName">
        <el-input v-model="editForm.linkName" placeholder="请输入链接名称" />
      </el-form-item>
      <el-form-item label="链接地址" prop="linkUrl">
        <el-input
          v-model="editForm.linkUrl"
          placeholder="请输入链接地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="链接类型" prop="linkType">
        <el-select v-model="editForm.linkType" placeholder="请选择链接类型">
          <dictionary-option code="navTopLinkType" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="editForm.status" placeholder="请选择状态">
          <dictionary-option code="commonStatus" />
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number
          v-model="editForm.sort"
          controls-position="right"
          :min="0"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handleSave" :loading="editLoading"
          >确 定</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import { getCurrentInstance, ref } from 'vue'

import { getById, add, update, getMaxSort } from '@/api/nav/top/link'

const { proxy } = getCurrentInstance()

const visible = ref(false)
const title = ref('')
const editLoading = ref(false)
const rules = ref({
  linkName: [{ required: true, message: '链接名称不能为空}', trigger: 'blur' }],
  linkUrl: [{ required: true, message: '链接地址不能为空}', trigger: 'blur' }]
})
const editForm = ref({
  id: undefined,
  linkName: undefined,
  linkUrl: undefined,
  linkType: '1',
  status: '1',
  sort: undefined
})

/**
 * 显示弹窗
 */
async function show(id) {
  visible.value = true
  if (id) {
    title.value = '修改导航顶部链接'
    // 获取角色信息
    const { data } = await getById(id)
    editForm.value = data
    editForm.value.linkType = editForm.value.linkType + ''
    editForm.value.status = editForm.value.status + ''
  } else {
    title.value = '新增导航顶部链接'
    editForm.value.id = undefined
    const { data } = await getMaxSort()
    editForm.value.sort = data ? data + 1 : 1
  }
}

/**
 * 关闭
 */
function close() {
  visible.value = false
  reset()
}

/**
 * 重置
 */
function reset() {
  proxy.resetForm('editFormRef')
}

/**
 * 提交数据
 */
const emit = defineEmits(null)
function handleSave() {
  proxy.$refs.editFormRef.validate(async (valid) => {
    if (valid) {
      editLoading.value = true
      try {
        // 修改
        if (editForm.value.id) {
          await update(editForm.value)
          proxy.$modal.msgSuccess('修改导航顶部链接成功')
        } else {
          // 新增
          await add(editForm.value)
          proxy.$modal.msgSuccess('新增导航顶部链接成功')
        }
        emit('fetch-data')
        close()
      } finally {
        editLoading.value = false
      }
    }
  })
}

defineExpose({
  show
})
</script>
